class ExtendedToggle {
	constructor($element) {
		this.$element = $($element);

		this.state = {
			isOpen: false,
		};
	}

	init() {
		this.checkboxEl = this.$element.find(':checkbox');
		this.toggleEl = this.$element.find('.extended-toggle__read-more-icon');
		this.updateActiveState();

		this.toggleEl.on('click', this.onToggleClick.bind(this));
		this.toggleEl.on('keydown', this.onkeydown.bind(this));
	}

	onkeydown(e) {
		if (e.code === 'Space' || e.code === 'Enter') {
			this.onToggleClick.bind(this)(e);
			e.preventDefault();
			e.stopPropagation();
		}
	}

	onToggleClick() {
		this.state.isOpen = !this.state.isOpen;
		this.toggleEl.attr('aria-expanded', this.state.isOpen);
		this.updateActiveState();
	}

	updateActiveState() {
		if (this.state.isOpen) {
			this.$element.addClass('extended-toggle--expanded');
		} else {
			this.$element.removeClass('extended-toggle--expanded');
		}

		// Force repaint for browsers that lack common sence... ex safari...
		const repaintHack = this.toggleEl[0];
		repaintHack.style.display = 'none';
		repaintHack.style.display = 'block';
	}
}

const extendedToggleInit = () => { // eslint-disable-line no-unused-vars
	const $elements = $('[data-extended-toggle]');
	$elements.each((i, el) => new ExtendedToggle(el).init());
};

export { extendedToggleInit };
